
export const CANCELLATION_REPORT_REQUEST = 'CANCELLATION_REPORT_REQUEST'
export const CANCELLATION_REPORT_SUCCESS = 'CANCELLATION_REPORT_SUCCESS'
export const CANCELLATION_REPORT_FAIL = 'CANCELLATION_REPORT_FAIL'
